import axios from "axios";
import { errorActions } from "../helpers/auth_helper";
import {
  IDRFPaginated,
  IMerchantCenterLogFilters,
  IMerchantCenterSyncLog,
  IMerchantCenterSyncStats,
  IMerchantCenterTriggerResponse,
} from "../interfaces/merchant_center_sync.interface";

const BASE = `${process.env.REACT_APP_API_URL}/google-merchant-sync`;

// ──────────────────────────── Stats ────────────────────────────────────

export async function getMerchantCenterSyncStats(): Promise<
  IMerchantCenterSyncStats | undefined
> {
  try {
    return await axios
      .get<IMerchantCenterSyncStats>(`${BASE}/stats/`)
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error fetching merchant center sync stats");
        return undefined;
      });
  } catch {
    return undefined;
  }
}

// ──────────────────────────── Logs ────────────────────────────────────

export async function getMerchantCenterSyncLogs(
  filters: IMerchantCenterLogFilters = {}
): Promise<IDRFPaginated<IMerchantCenterSyncLog> | undefined> {
  try {
    const params: Record<string, string | number> = {
      page: filters.page ?? 1,
      page_size: filters.page_size ?? 20,
    };
    if (filters.status) params.status = filters.status;
    if (filters.action) params.action = filters.action;
    if (filters.category_id) params.category_id = filters.category_id;
    if (filters.created_at_from) params.created_at_from = filters.created_at_from;
    if (filters.created_at_to) params.created_at_to = filters.created_at_to;

    return await axios
      .get<IDRFPaginated<IMerchantCenterSyncLog>>(`${BASE}/logs/`, { params })
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error fetching merchant center sync logs");
        return undefined;
      });
  } catch {
    return undefined;
  }
}

// ──────────────────────────── Trigger ────────────────────────────────────

export async function triggerMerchantCenterSync(params?: {
  category_id?: number;
}): Promise<IMerchantCenterTriggerResponse | undefined> {
  try {
    return await axios
      .post<IMerchantCenterTriggerResponse>(`${BASE}/trigger/`, params ?? {})
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error triggering merchant center sync");
        return undefined;
      });
  } catch {
    return undefined;
  }
}

// ──────────────────────────── Reconcile ────────────────────────────────────

export async function triggerMerchantCenterReconcile(): Promise<
  IMerchantCenterTriggerResponse | undefined
> {
  try {
    return await axios
      .post<IMerchantCenterTriggerResponse>(`${BASE}/reconcile/`, {})
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error triggering merchant center reconcile");
        return undefined;
      });
  } catch {
    return undefined;
  }
}
